<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newMarketingAction()"
                aria-label="Add action"
                *appIsGranted="['Marketing actions', 'CREATE']"
        >
            {{'Add action'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">

        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
